module.exports = __webpack_public_path__ + "img/kjfn.d5592da.png";